import { constraintConfig } from '../../constraintConfig'

type Props = {
    statusId?: number | string | null
    statusTitle?: string | null
}

const CreditCardRequestStatusComp = ({ statusId, statusTitle }: Props) => {
    const id = Number(statusId ?? 0)
    const title = statusTitle || 'N/A'

    if (!id || !statusTitle) {
        return <span className='badge badge-light-secondary fs-7 fw-semibold'>N/A</span>
    }

    if (id === constraintConfig.ccCardRequestStatus.Requested) {
        return <span className='badge badge-light-primary fs-7 fw-semibold'>{title}</span>
    }
    if (id === constraintConfig.ccCardRequestStatus.RequestApproved) {
        return <span className='badge badge-light-success fs-7 fw-semibold'>{title}</span>
    }
    if (id === constraintConfig.ccCardRequestStatus.RequestRejected) {
        return <span className='badge badge-light-danger fs-7 fw-semibold'>{title}</span>
    }
    if (id === constraintConfig.ccCardRequestStatus.CreditCardOrdered) {
        return <span className='badge badge-light-info fs-7 fw-semibold'>{title}</span>
    }
    if (id === constraintConfig.ccCardRequestStatus.Cancel) {
        return <span className='badge badge-light-dark fs-7 fw-semibold'>{title}</span>
    }
    if (id === constraintConfig.ccCardRequestStatus.RequestExpired) {
        return <span className='badge badge-light-warning fs-7 fw-semibold'>{title}</span>
    }

    return <span className='badge badge-light-primary fs-7 fw-semibold'>{title}</span>
}

export default CreditCardRequestStatusComp
